"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../../core/model/DomainObject");

var SelloutImpactRecord_1 = require("./SelloutImpactRecord");
/**
 * Contains values from `SelloutImpactRecord` needed in overviews on the release page for all opens.
 *
 * @author Jan Prokop
 */


var SelloutImpactRecordValuesForOpen =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutImpactRecordValuesForOpen, _DomainObject_1$Domai);

  function SelloutImpactRecordValuesForOpen(releaseId, categoryId, reopen, discountPercent) {
    var _this;

    _classCallCheck(this, SelloutImpactRecordValuesForOpen);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutImpactRecordValuesForOpen).call(this));
    _this.releaseId = releaseId;
    _this.categoryId = categoryId;
    _this.reopen = reopen;
    _this.discountPercent = discountPercent;
    return _this;
  }

  _createClass(SelloutImpactRecordValuesForOpen, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new SelloutImpactRecordValuesForOpen(mat.releaseId, mat.categoryId, mat.reopen, mat.discountPercent);
    }
  }]);

  return SelloutImpactRecordValuesForOpen;
}(DomainObject_1.DomainObject);

exports.SelloutImpactRecordValuesForOpen = SelloutImpactRecordValuesForOpen;
SelloutImpactRecordValuesForOpen.schema = {
  releaseId: SelloutImpactRecord_1.SelloutImpactRecord.schema.releaseId,
  categoryId: SelloutImpactRecord_1.SelloutImpactRecord.schema.categoryId,
  reopen: SelloutImpactRecord_1.SelloutImpactRecord.schema.reopen,
  discountPercent: SelloutImpactRecord_1.SelloutImpactRecord.schema.discountPercent
};